module.exports = ".nav-to-div{\r\n    padding-top: 70px;\r\n}\r\n"